import {Injectable} from "@angular/core";
import {Subject} from "rxjs";
import {UserContextProxy, UserContextService} from "../../../../../app.services/user.context";
import {debounceTime, mergeMap} from "rxjs/operators";

export interface IPopupPosition{
	topPx:number;
	leftPx:number;

	size?:{
		widthPx:number;
		heightPx:number;
	}
}

export type PopupsPositions = Map<string,IPopupPosition>;

@Injectable({ providedIn: 'root' })
  export class PopupPositionStore {
	private store: PopupsPositions;
	private readonly SECONDS_TO_WAIT_BEFORE_SEND=10;
	private positionUpdatesSubject: Subject<PopupsPositions>;

	constructor(private userCtxProxy:UserContextProxy, private userCtx:UserContextService) {
		this.positionUpdatesSubject = new Subject<PopupsPositions>();
		this.positionUpdatesSubject.asObservable().pipe(
			debounceTime(this.SECONDS_TO_WAIT_BEFORE_SEND*1000),
			mergeMap(x=>{return this.userCtxProxy.setPopupLocations(x);})).subscribe(x=>{
				//just to make sure we subscribe to heat-up the observable
		});
	}

	// private sendToServer(position:PopupsPositions){
	// 	this.userCtxProxy.setPopupLocations(position)
	// }
	private initStore(){
		if (!this.store){
			let baseObj=this.userCtx.getLoginDataPopupPositions()||{};
			this.store=new Map<string, IPopupPosition>();
			Object.keys(baseObj).map(currPositionToken=>{
				this.store.set(currPositionToken,baseObj[currPositionToken]);
			});
		}
	}
	public getPoistion(token:string) : IPopupPosition{
		if (!token){
			// this is the place we handle undefined values - the popups dont have a special handling
			return undefined;
		}
		this.initStore();
		return this.store.get(token);
	}

	public setPoistion(token:string,position:IPopupPosition){
		if (!token){
			// this is the place we handle undefined values - the popups dont have a special handling
			return;
		}

		this.initStore();
		this.store.set(token,position);

		this.positionUpdatesSubject.next(this.store);
	}

}
